<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolSll_2d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolSll_2d00 from '@/device-products/ResolDeltaSolSll_2d00.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolSll_2d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
